/**
 * Copyright Highway9 Networks Inc.
 */

/** Metric names for IPSEC cert pool aggregate (`POST /edges/metrics/aggregate`). */
export const IPSEC_CERT_POOL_METRICS = [
  "cert_pool_total_available",
  "cert_pool_total_allocated",
  "cert_pool_total_used",
  "deployed_edges_total",
] as const;

export type IpsecCertPoolMetricName = (typeof IPSEC_CERT_POOL_METRICS)[number];

export type CertPoolSnapshot = Record<IpsecCertPoolMetricName, number>;

export type CertPoolTimeSeriesPoint = CertPoolSnapshot & {
  timestamp: string;
};

export type EdgeMetricsAggregateData = {
  snapshot: CertPoolSnapshot;
  timeSeries: CertPoolTimeSeriesPoint[];
};

export type EdgeMetricsAggregateMeta = {
  resolutionSeconds: number;
  currency: string;
  generatedAt: string;
};

export type EdgeMetricsAggregateResponse = {
  requestId: string;
  status: string;
  data: EdgeMetricsAggregateData;
  meta: EdgeMetricsAggregateMeta;
};

export type EdgeMetricsAggregateRequest = {
  metrics: string[];
  interval: {
    startTime: number;
    endTime: number;
  };
  resolution: number;
};

export type RawEdgeMetricsAggregateItem = {
  metric: IpsecCertPoolMetricName;
  metricData?: [number | string, number | string][];
};

/** `GET /serviceInstances` row for IPSEC cert allocation per VMC. */
export type IpsecVmcAllocation = {
  id: string;
  name: string;
  tenantId?: string;
  tenantName?: string;
  deploymentCloud?: {
    id?: string;
  };
  edgeSummary?: {
    totalCount?: number;
  };
  certificateSummary: {
    allocatedCount?: number;
    usedCount?: number;
    autoAddedUsedCount?: number;
    manualAddedCount?: number;
    deployedEdgeCount?: number;
  };
  updatedAt: string;
};

export type IpsecVmcAllocationsResponse = {
  requestId: string;
  status: string;
  data: IpsecVmcAllocation[];
};
